import { tracker, ETrackerActions, ETrackerChapters, ETrackerPages } from '../ClickStreamTracker';

export function useAuthTracker() {
  const trackAuthSuccess = () => {
    try {
      tracker.trackWithEventName(
        'market_auth_success' as any,
        {
          chapter: ETrackerChapters.MARKET,
          page: ETrackerPages.AUTH,
          block: '',
          element: '',
          action: ETrackerActions.SUCCESS,
          referer: 'phoneNumber',
        }
      );
    } catch (error) {
      console.error('Failed to send market_auth_success event:', error);
    }
  };

  return {
    trackAuthSuccess,
  };
}
